import React from 'react';
import {Card, CardActionArea, CardContent, Grid, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {EXAMPLES_ROUTE} from '../../utils/consts';
import {getImageUrl} from "../../helpers/getImageUrl";

const CollageItem = ({collage}) => {
        const navigate = useNavigate();
        const content = collage.description ? collage.description.substring(0, 90) + "..." : '';

        return (
            <Card
                sx={{
                    width: '100%', // Full width for vertical list
                    border: 1,
                    borderColor: 'grey.300',
                    borderRadius: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                }}
                elevation={0}
            >
                <CardActionArea
                    sx={{flex: '0 1 auto'}}
                    onClick={() => navigate(`${EXAMPLES_ROUTE}/collage/${collage.id}`)}
                >
                    <CardContent
                        sx={{
                            paddingBottom: 0,
                        }}
                    >
                        <Typography variant="h6">{collage.ClinicService.name}</Typography>
                        <Typography variant="body2" color="textSecondary">
                            {content}
                        </Typography>
                        <Typography variant="body2" color="templateText.secondary">
                            Автор: {collage.user?.internalName || collage.user?.name || collage.authorInternalNameSnapshot || collage.authorNameSnapshot || 'Неизвестно'}
                        </Typography>

                        {/* Horizontal list of images */}
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                mt: 2,
                                flexWrap: 'nowrap', // Horizontal scrolling
                                overflowX: 'auto', // Enable horizontal scrolling
                                paddingBottom: 2,
                                '&::-webkit-scrollbar': {
                                    height: '6px', // Thin scrollbar
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'grey.400',
                                    borderRadius: '4px',
                                },
                            }}
                        >
                            {collage.images?.map((img, index) => (
                                <Grid item key={index}>
                                    <div
                                        style={{
                                            width: '60px', // Fixed width for images
                                            height: '60px', // Fixed height for cropping
                                            overflow: 'hidden',
                                            borderRadius: '4px',
                                            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                        <img
                                            src={getImageUrl(img.image)}
                                            alt={`Изображение ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                objectPosition: 'center',
                                            }}
                                        />
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </CardActionArea>
            </Card>
        );
    }
;

export default CollageItem;
